import { navigateFullPage } from "@/utils/fullPageNavigation";
import { PATHS } from "@/shared/publicPaths";

const SearchService = () => {
  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const filter = encodeURIComponent(String(formData.get("text") ?? ""));

    navigateFullPage(`${PATHS.services}?filter=${filter}`);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 20,
          width: "100%",
          maxWidth: "400px",
          backgroundColor: "#fff",
          boxShadow: "0px 7px 18px rgba(64, 79, 104, 0.05)",
          borderRadius: "20px 0px 0px 20px",
          overflow: "hidden",
        }}
      >
        {/* <!-- Form Group --> */}
        <div style={{ flex: "1 1 0" }}>
          <input
            id="text"
            type="text"
            name="text"
            placeholder="¿Qué tarea necesitas?"
            style={{
              fontSize: 15,
              color: "#696969",
              padding: "0px 0px 0px 20px",
              height: 38,
              width: "100%",
              minWidth: "200px",
            }}
          />
        </div>

        {/* <!-- Form Group --> */}
        <div style={{ flex: "0 0 120px" }}>
          <button
            type="submit"
            style={{
              backgroundColor: "var(--primary-color)",
              color: "white",
              borderRadius: 50,
              padding: "5px 0px",
              fontWeight: 600,
              fontSize: 15,
              width: "120px",
            }}
          >
            Buscar
          </button>
        </div>
      </div>
    </form>
  );
};

export default SearchService;
